import { css, cva } from '@/styled-system/css';

export const comboboxContentRecipe = cva({
  base: {
    borderRadius: 'Combobox.Content',
    backgroundColor: 'Combobox.Content.bg',
    boxShadow: 'Combobox.Content',
    position: 'relative',
    overflow: 'auto',
    maxHeight: 'Combobox.Content.height.max',
  },
  variants: {
    dividers: {
      true: {
        '& [data-c11n-component="Combobox.Group"]:not(:last-child)': {
          borderBottomWidth: 'Combobox.Group',
          borderBottomStyle: 'solid',
          borderBottomColor: 'Combobox.Group.border',
        },
      },
      false: {},
    },
  },
});

export const comboboxContentPositionerStyles = css.raw({
  zIndex: 'combobox',
});
